export default "__VITE_ASSET__a0af637c__"